import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AvatarsAPI } from '../../../../../constructs/avatars/interface';
import { PosterAPI } from '../../../../../constructs/poster-processing/interface';

interface UploadAssetParams {
  file: File;
  avatarGroupId?: string;
  avatarName?: string;
}

export const useUploadAsset = () => {
  const { callEndpoint } = useAPIContext();
  const [isUploading, setIsUploading] = React.useState(false);
  const [uploadProgress, setUploadProgress] = React.useState('');

  const uploadAsset = React.useCallback(
    async (params: UploadAssetParams) => {
      try {
        const { file } = params;
        const ext = `.${file.name.split('.').pop()?.toLowerCase()}`;
        const fileName = file.name.replace(/\.[^.]+$/, '');

        // Upload directo a S3 con prefix avatars/assets
        const response = await callEndpoint<PosterAPI, 'post'>('upload', `/direct/${fileName}`, 'POST', {
          fileType: 'image',
          fileExtension: ext,
          optionalPrefix: 'avatars/assets'
        });

        const s3Response = await fetch(response.uploadUrl, {
          method: 'PUT',
          body: file,
          headers: { 'Content-Type': file.type }
        });

        if (!s3Response.ok) {
          throw new Error(`Error subiendo archivo a S3: ${s3Response.status}`);
        }

        // Registrar en HeyGen y DynamoDB
        const res = await callEndpoint<AvatarsAPI, 'upload-avatar-asset'>('avatars', '/upload', 'POST', {
          s3Key: response.fileKey,
          fileName,
          avatarGroupId: params.avatarGroupId,
          avatarName: params.avatarName
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');
        return res;
      } catch (error: any) {
        console.error('Error en uploadAsset:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { uploadAsset, isUploading, setIsUploading, uploadProgress, setUploadProgress };
};
